module.exports = __webpack_public_path__ + "static/img/female-6.e62059bb.png";